import {AiImageSizeEnum, AiPostTypeEnum} from '../../../../../../../../../service/posts/posts-types';

export enum AiGenerationStepEnum {
    Settings = 'settings',
    Loading = 'loading',
    Result = 'result',
}

export type AiGenerationSettingsDraftType = {
    postType: AiPostTypeEnum | null;
    userPrompt: string;
    generateImage: boolean;
    imageSize: AiImageSizeEnum;
    imageCount: number;
};
